import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useMemo,
  FC,
  useCallback,
} from "react";
import { getTokens, removeTokens, handleError } from "../shared/utils";
import { useHistory } from "react-router-dom";
import { useSubscription } from "@cobuildlab/react-simple-state";
import { fetchMeAction, fetchMeBasicAction } from "../api/me/me-actions";
import { OnFetchMe, OnFetchMeError } from "../api/me/me-events";
import { User } from "@devsplan/wealthclub-shared";
import { DASHBOARD_ROUTE, LOGIN_ROUTE } from "../shared/constants";
import { logoutMe } from "../api/me/me";
// import { useTranslation } from "react-i18next";

const AuthContext: any = createContext(null);

export const Provider: FC = ({ children }) => {
  const [state, setState] = useState<{
    tokenError?: boolean;
    user: User | null;
  }>({
    tokenError: false,
    user: null,
  });
  const { user } = state;
  const history = useHistory();
  // const { t } = useTranslation();
  const tokens = getTokens();
  const { token } = useMemo(() => {
    return tokens;
  }, [tokens]);

  const goToLogin = useCallback(() => {
    history.push(LOGIN_ROUTE);
  }, [history]);

  const getSession = () => {
    if (token) {
      fetchMeAction();
      fetchMeBasicAction();
    }
  };
  const logout = useCallback(() => {
    logoutMe().then(() => {
      removeTokens();
      setState({ user: null });
      goToLogin();
      OnFetchMe.dispatch(null);
    });
  }, [goToLogin]);

  useSubscription(
    OnFetchMe,
    (user) => {
      setState({ user });

      if (LOGIN_ROUTE === window.location.pathname) {
        history.push(DASHBOARD_ROUTE);
      }
    },
    []
  );

  useSubscription(
    OnFetchMeError,
    async (error: any) => {
      removeTokens();
      setState({ user: null });
      goToLogin();
      handleError(error);
    },
    []
  );

  useEffect(() => {
    getSession();
    // eslint-disable-next-line
  }, []);

  const value = useMemo(() => {
    return { user, logout };
    // eslint-disable-next-line
  }, [user]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = (): { user: User; logout: Function } => {
  const { user, logout } = useContext(AuthContext);

  return { user, logout };
};
